import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  getCoursesByUser,
  getFeaturedCourses,
} from "../../../redux/features/course/courseService";
import styles from "./index.module.css";
import SkeletonCourseCard from "../../../components/Skeleton/CourseCardSekeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCalendarCheck, faClock, faUser } from "@fortawesome/free-regular-svg-icons";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import NoResultsFound from "../../../components/NoResultsFound";

const MyCourses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isPurchasedCoursesLoading, purchasedCourses } = useSelector(
    (state) => state.course.purchasedCourses
  );

  useEffect(() => {
    dispatch(getCoursesByUser());
  }, [dispatch]);

  const openCourse = (slug) => {
    navigate(`/courses/${slug}`);
  };

  return (
    <div className={`main-container`}>
      <div className={`container-content`}>
        <>
          {isPurchasedCoursesLoading ? (
            <div className={styles.homeContainer}>
              <div className={`main-container`}>
                <div className={`container-content`}>
                  <div className={styles.homeHeader}></div>
                  <div className={styles.courseList}>
                    {Array.from({ length: 3 }).map((_, index) => (
                      <div className={styles.courseCard} key={index}>
                        <div className={styles.courseCardContent}>
                          <div className={styles.courseCardLeft}>
                            <Skeleton
                              className={styles.thumbImg}
                            />
                          </div>
                          <div className={styles.courseCardRight}>
                            <div>
                              <p className={styles.title}>
                                <Skeleton />
                              </p>
                              <p className={styles.descriptionLines}>
                                <Skeleton />
                                <Skeleton />
                                <Skeleton />
                              </p>
                              <div className={styles.iconRow}>
                                <Skeleton width={120} />
                                <Skeleton width={120} />
                              </div>
                              <div className={styles.iconRow} style={{ marginTop: '20px', marginBottom: '20px' }}>
                                <div className={styles.iconDisplayRow}>
                                  <Skeleton width={240} />
                                </div>
                              </div>
                            </div>
                            <Skeleton height={40} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            purchasedCourses?.length > 0 ? (
              <div className={styles.homeContainer}>
                {/* <div className={`main-container`}> */}
                <div className={`container-content`}>
                  <div className={styles.homeHeader}></div>
                  <div className={styles.courseList}>
                    {purchasedCourses?.map((course) => (
                      <div className={styles.courseCard} key={course?.id}>
                        <div className={styles.courseCardContent}>
                          <div className={styles.courseCardLeft}>
                            <img
                              src={course?.course?.image_url}
                              className={styles.thumbImg}
                            />
                          </div>
                          <div className={styles.courseCardRight}>
                            <div>
                              <p className={styles.title}>
                                {course?.course?.title}
                              </p>
                              <p className={styles.descriptionLines}>
                                {course?.course?.description}
                              </p>
                              <div className={styles.iconRow}>
                                <div className={styles.iconDisplayRow}>
                                  <span className={styles.iconWrapper}>
                                    <FontAwesomeIcon
                                      icon={faClock}
                                      className={styles.icon}
                                    />
                                  </span>
                                  {course?.course?.duration}
                                </div>
                                <div className={styles.iconDisplayRow}>
                                  <span className={styles.iconWrapper}>
                                    <FontAwesomeIcon
                                      icon={faUserGroup}
                                      className={styles.icon}
                                    />
                                  </span>
                                  {course?.course?.download === 0 ? 10 : course?.course?.download}
                                </div>
                              </div>
                              <div className={styles.iconRow} style={{ marginTop: '20px', marginBottom: '20px' }}>
                                <div className={styles.iconDisplayRow}>
                                  <span className={styles.iconWrapper}>
                                    <FontAwesomeIcon
                                      icon={faUser}
                                      className={styles.icon}
                                    />
                                  </span>
                                  {course?.course?.user?.full_name}
                                </div>
                              </div>
                            </div>
                            <Link
                              to={`/my-courses/${course?.course?.slug}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.viewMoreBtn}
                            >
                              Resume
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* </div> */}
              </div>
            ) : (
              <div className={styles.homeContainer}>
                <div className={`container-content`}>
                  <div className={styles.homeHeader}></div>
                  <div className={styles.courseList}>
                    <NoResultsFound />
                  </div>
                </div>
              </div>
            )
          )}
        </>
      </div>
    </div>
  );
};

export default MyCourses;
